const CITIES = {
  'new-york': {
    name: 'New York', state: 'NY', population: '8.3M', restaurants: '26,000+',
    tagline: 'The city that never stops eating',
    foodScene: 'New York City is arguably the world\'s greatest food city. From Michelin-starred tasting menus in Manhattan to $1 pizza slices in Brooklyn, the diversity is staggering. Every cuisine on Earth is represented — often within a single subway stop.',
    topCuisines: [
      { emoji: '🍕', name: 'Pizza', note: 'Dollar slices to coal-fired Neapolitan' },
      { emoji: '🥯', name: 'Bagels & Deli', note: 'Pastrami on rye, lox & schmear' },
      { emoji: '🍜', name: 'Chinese', note: 'Flushing & Chinatown dim sum' },
      { emoji: '🍣', name: 'Japanese', note: 'Omakase counters & ramen bars' },
      { emoji: '🍝', name: 'Italian', note: 'Arthur Ave to Little Italy' },
      { emoji: '🌮', name: 'Mexican', note: 'Jackson Heights street tacos' }
    ],
    neighborhoods: ['Manhattan', 'Williamsburg', 'Astoria', 'Flushing', 'Harlem', 'West Village'],
    knownFor: 'Dollar pizza, pastrami sandwiches, bagels, Chinatown, fine dining capital of the US',
    nearby: ['philadelphia', 'boston', 'washington-dc']
  },
  'los-angeles': {
    name: 'Los Angeles', state: 'CA', population: '3.9M', restaurants: '15,000+',
    tagline: 'Where every cuisine has its own neighborhood',
    foodScene: 'LA\'s food scene is driven by cultural diversity and year-round outdoor dining. Korean BBQ in Koreatown, street tacos on every corner, farm-to-table in Silver Lake. The sprawl means your group is probably scattered across 15 miles — Hangrily helps find a spot that works for everyone.',
    topCuisines: [
      { emoji: '🌮', name: 'Mexican', note: 'Birria tacos to Oaxacan mole' },
      { emoji: '🥘', name: 'Korean', note: 'Koreatown BBQ & fried chicken' },
      { emoji: '🍣', name: 'Japanese', note: 'Little Tokyo ramen & sushi' },
      { emoji: '🌯', name: 'Armenian', note: 'Glendale kebabs & bakeries' },
      { emoji: '🥗', name: 'Health-Conscious', note: 'Juice bars & açaí bowls' },
      { emoji: '🍔', name: 'Burgers', note: 'In-N-Out to smash burger joints' }
    ],
    neighborhoods: ['Koreatown', 'Silver Lake', 'West Hollywood', 'Santa Monica', 'DTLA', 'Venice'],
    knownFor: 'Street tacos, Korean BBQ, In-N-Out, celebrity chef restaurants, outdoor dining',
    nearby: ['san-diego', 'san-francisco', 'las-vegas']
  },
  'chicago': {
    name: 'Chicago', state: 'IL', population: '2.7M', restaurants: '8,000+',
    tagline: 'Deep dish is just the beginning',
    foodScene: 'Chicago punches above its weight as a food city. Beyond deep-dish pizza, you\'ll find James Beard winners, molecular gastronomy at Alinea, legendary Italian beef, and a booming West Loop restaurant row. Each neighborhood has its own culinary identity.',
    topCuisines: [
      { emoji: '🍕', name: 'Deep Dish Pizza', note: 'Lou Malnati\'s, Giordano\'s & more' },
      { emoji: '🥩', name: 'Steakhouses', note: 'World-class chophouses' },
      { emoji: '🌭', name: 'Chicago Dogs', note: 'Mustard, relish, never ketchup' },
      { emoji: '🥖', name: 'Italian Beef', note: 'Giardiniera & sweet peppers' },
      { emoji: '🌮', name: 'Mexican', note: 'Pilsen & Little Village taquerias' },
      { emoji: '🍜', name: 'Asian Fusion', note: 'Chinatown & Argyle Street' }
    ],
    neighborhoods: ['West Loop', 'Wicker Park', 'Lincoln Park', 'Pilsen', 'River North', 'Logan Square'],
    knownFor: 'Deep-dish pizza, Italian beef, Chicago hot dogs, Michelin dining, West Loop',
    nearby: ['milwaukee', 'indianapolis', 'detroit']
  },
  'houston': {
    name: 'Houston', state: 'TX', population: '2.3M', restaurants: '7,500+',
    tagline: 'The most diverse food city in America',
    foodScene: 'Houston is America\'s most ethnically diverse city, and its food reflects that. Vietnamese pho in Midtown, Nigerian suya in Alief, Salvadoran pupusas on Hillcroft. Incredible restaurants pop up in strip malls — you need Hangrily to find the gems.',
    topCuisines: [
      { emoji: '🌮', name: 'Tex-Mex', note: 'Breakfast tacos & fajitas' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Midtown pho & banh mi' },
      { emoji: '🍖', name: 'BBQ', note: 'Texas brisket & beef ribs' },
      { emoji: '🦐', name: 'Cajun/Creole', note: 'Gulf Coast seafood boils' },
      { emoji: '🍛', name: 'Indian/Pakistani', note: 'Hillcroft corridor gems' },
      { emoji: '🥘', name: 'Nigerian', note: 'Alief & Southwest Houston' }
    ],
    neighborhoods: ['Montrose', 'Midtown', 'Heights', 'EaDo', 'Bellaire', 'Alief'],
    knownFor: 'Tex-Mex, BBQ, Vietnamese food, strip mall gems, breakfast tacos, Gulf seafood',
    nearby: ['dallas', 'san-antonio', 'austin']
  },
  'phoenix': {
    name: 'Phoenix', state: 'AZ', population: '1.7M', restaurants: '5,000+',
    tagline: 'Desert heat, fiery flavors',
    foodScene: 'Phoenix\'s food scene has exploded. Sonoran-style Mexican food is the backbone — cheese crisps, chimichangas (invented here), and green chile everything. Scottsdale adds upscale dining, while South Phoenix has the most authentic Mexican food north of the border.',
    topCuisines: [
      { emoji: '🌮', name: 'Sonoran Mexican', note: 'Chimichangas & cheese crisps' },
      { emoji: '🌵', name: 'Southwestern', note: 'Green chile, prickly pear' },
      { emoji: '🥩', name: 'Steakhouses', note: 'Scottsdale fine dining' },
      { emoji: '🍔', name: 'American', note: 'Craft burgers & brewpubs' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Growing scene on 19th Ave' },
      { emoji: '🥗', name: 'Health & Juice', note: 'Wellness-focused cafes' }
    ],
    neighborhoods: ['Scottsdale', 'Old Town', 'Downtown Phoenix', 'Tempe', 'Arcadia', 'South Phoenix'],
    knownFor: 'Sonoran Mexican, chimichangas, Scottsdale fine dining, desert-inspired cuisine',
    nearby: ['tucson', 'las-vegas', 'albuquerque']
  },
  'philadelphia': {
    name: 'Philadelphia', state: 'PA', population: '1.6M', restaurants: '4,500+',
    tagline: 'Way more than cheesesteaks',
    foodScene: 'Philly\'s food identity runs deep — cheesesteaks are just the tourist layer. Underneath you\'ll find a thriving BYOB culture, Italian Market heritage, a booming Chinatown, and Reading Terminal Market. The city consistently outperforms its size in James Beard nominations.',
    topCuisines: [
      { emoji: '🥩', name: 'Cheesesteaks', note: 'Pat\'s vs Geno\'s vs everywhere else' },
      { emoji: '🥨', name: 'Soft Pretzels', note: 'A Philly obsession' },
      { emoji: '🍝', name: 'Italian', note: '9th Street Italian Market' },
      { emoji: '🥡', name: 'Chinese', note: 'Chinatown dim sum & noodles' },
      { emoji: '🍽️', name: 'BYOB Dining', note: 'World-class food, bring your wine' },
      { emoji: '🦀', name: 'Seafood', note: 'Jersey Shore-fresh oysters & crab' }
    ],
    neighborhoods: ['Rittenhouse', 'Fishtown', 'Old City', 'South Philly', 'University City', 'Northern Liberties'],
    knownFor: 'Cheesesteaks, soft pretzels, BYOB restaurants, Reading Terminal Market',
    nearby: ['new-york', 'washington-dc', 'baltimore']
  },
  'san-antonio': {
    name: 'San Antonio', state: 'TX', population: '1.5M', restaurants: '4,000+',
    tagline: 'Where Tex-Mex was born',
    foodScene: 'San Antonio is the cradle of Tex-Mex cuisine and home to the puffy taco. The Pearl District has become a culinary destination, while the Riverwalk offers everything from casual to upscale dining with a view.',
    topCuisines: [
      { emoji: '🌮', name: 'Tex-Mex', note: 'Puffy tacos & enchiladas' },
      { emoji: '🍖', name: 'BBQ', note: 'Central Texas-style brisket' },
      { emoji: '🫔', name: 'Tamales', note: 'Handmade family recipes' },
      { emoji: '🍳', name: 'Breakfast Tacos', note: 'Barbacoa & Big Red' },
      { emoji: '🥘', name: 'Mexican Interior', note: 'Mole, pozole, birria' },
      { emoji: '🍻', name: 'Brewpubs', note: 'Growing craft scene' }
    ],
    neighborhoods: ['Pearl District', 'Riverwalk', 'Southtown', 'King William', 'Alamo Heights', 'Stone Oak'],
    knownFor: 'Puffy tacos, barbacoa, Tex-Mex, Riverwalk dining, Pearl District',
    nearby: ['austin', 'houston', 'el-paso']
  },
  'san-diego': {
    name: 'San Diego', state: 'CA', population: '1.4M', restaurants: '5,500+',
    tagline: 'Baja-inspired and ocean-fresh',
    foodScene: 'San Diego sits on the Mexican border, giving it the best of both worlds: authentic Baja Mexican food and California farm-to-table. Fish tacos are practically a religion. The craft beer scene is one of America\'s best with 150+ breweries.',
    topCuisines: [
      { emoji: '🐟', name: 'Fish Tacos', note: 'Baja-style, the city\'s signature' },
      { emoji: '🌮', name: 'Mexican', note: 'Border-proximity authenticity' },
      { emoji: '🍺', name: 'Craft Beer', note: '150+ breweries' },
      { emoji: '🦞', name: 'Seafood', note: 'Pacific-fresh daily' },
      { emoji: '🍝', name: 'Italian', note: 'Little Italy neighborhood' },
      { emoji: '🥑', name: 'California Cuisine', note: 'Avocado toast capital' }
    ],
    neighborhoods: ['North Park', 'Little Italy', 'Gaslamp Quarter', 'Hillcrest', 'La Jolla', 'Pacific Beach'],
    knownFor: 'Fish tacos, craft beer capital, Baja Mexican, Little Italy, ocean-view dining',
    nearby: ['los-angeles', 'phoenix', 'las-vegas']
  },
  'dallas': {
    name: 'Dallas', state: 'TX', population: '1.3M', restaurants: '6,000+',
    tagline: 'Big city dining, Texas style',
    foodScene: 'Dallas has transformed from steakhouse-and-Tex-Mex into one of the South\'s most exciting food cities. Bishop Arts, Deep Ellum, and Trinity Groves are incubators for creative restaurants. Texas BBQ includes nationally-ranked spots alongside Korean, Ethiopian, and Vietnamese gems.',
    topCuisines: [
      { emoji: '🥩', name: 'Steakhouses', note: 'Texas beef at its finest' },
      { emoji: '🍖', name: 'BBQ', note: 'Pecan Lodge & Cattleack' },
      { emoji: '🌮', name: 'Tex-Mex', note: 'Margarita-fueled classics' },
      { emoji: '🥘', name: 'Korean', note: 'Koreatown on Royal Lane' },
      { emoji: '🍗', name: 'Southern Comfort', note: 'Chicken-fried steak & biscuits' },
      { emoji: '🍜', name: 'Vietnamese', note: 'Garland pho & banh mi' }
    ],
    neighborhoods: ['Bishop Arts', 'Deep Ellum', 'Uptown', 'Trinity Groves', 'Knox-Henderson', 'Lower Greenville'],
    knownFor: 'Texas BBQ, steakhouses, Tex-Mex, Bishop Arts District, brunch culture',
    nearby: ['fort-worth', 'houston', 'austin']
  },
  'austin': {
    name: 'Austin', state: 'TX', population: '1M', restaurants: '4,500+',
    tagline: 'Keep Austin eating weird',
    foodScene: 'Austin\'s food scene is eclectic as the city itself. Famous for BBQ (Franklin\'s line wraps around the block), a legendary food truck culture with 1,000+ trailers, and a brunch obsession. East Austin has the most creative new restaurants.',
    topCuisines: [
      { emoji: '🍖', name: 'BBQ', note: 'Franklin, la Barbecue, Micklethwait' },
      { emoji: '🌮', name: 'Tacos', note: 'Breakfast tacos are a way of life' },
      { emoji: '🚚', name: 'Food Trucks', note: '1,000+ trailers citywide' },
      { emoji: '🍳', name: 'Brunch', note: 'Weekend ritual everywhere' },
      { emoji: '🌶️', name: 'Tex-Mex', note: 'Queso, migas, enchiladas' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Brewery-restaurant combos' }
    ],
    neighborhoods: ['South Congress', 'East Austin', 'Rainey Street', 'North Loop', 'South Lamar', 'Domain'],
    knownFor: 'Franklin BBQ, breakfast tacos, food truck culture, South Congress, live music & food',
    nearby: ['san-antonio', 'houston', 'dallas']
  },
  'san-francisco': {
    name: 'San Francisco', state: 'CA', population: '875K', restaurants: '5,000+',
    tagline: 'Where food movements are born',
    foodScene: 'San Francisco is where farm-to-table started, where sourdough became an identity, and where the Mission burrito achieved legendary status. Chinatown is the oldest in North America, and the city has more restaurants per capita than almost any US city.',
    topCuisines: [
      { emoji: '🌯', name: 'Mission Burritos', note: 'The city\'s greatest contribution' },
      { emoji: '🍞', name: 'Sourdough', note: 'Boudin & artisan bakeries' },
      { emoji: '🥡', name: 'Chinese', note: 'Oldest Chinatown in North America' },
      { emoji: '🍣', name: 'Japanese', note: 'Japantown & Outer Sunset' },
      { emoji: '🦀', name: 'Seafood', note: 'Dungeness crab at Fisherman\'s Wharf' },
      { emoji: '🥗', name: 'Farm-to-Table', note: 'The movement started here' }
    ],
    neighborhoods: ['Mission District', 'Chinatown', 'Hayes Valley', 'North Beach', 'Sunset', 'SOMA'],
    knownFor: 'Mission burritos, sourdough, Chinatown, Dungeness crab, farm-to-table',
    nearby: ['san-jose', 'sacramento', 'los-angeles']
  },
  'seattle': {
    name: 'Seattle', state: 'WA', population: '750K', restaurants: '4,000+',
    tagline: 'Coffee, seafood, and everything in between',
    foodScene: 'Seattle\'s food is defined by Pacific Northwest bounty — wild salmon, Dungeness crab, oysters, and foraged mushrooms. Pike Place Market is the heart, but Capitol Hill, Ballard, and Fremont each have distinct food identities. The Asian food is exceptional and the coffee culture unmatched.',
    topCuisines: [
      { emoji: '🐟', name: 'Seafood', note: 'Wild salmon & Dungeness crab' },
      { emoji: '☕', name: 'Coffee Culture', note: 'World capital of indie roasters' },
      { emoji: '🍜', name: 'Vietnamese', note: 'International District pho' },
      { emoji: '🍣', name: 'Japanese', note: 'Sushi & izakaya bars' },
      { emoji: '🥘', name: 'PNW Farm-to-Table', note: 'Seasonal, forager-driven' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Ballard brewery district' }
    ],
    neighborhoods: ['Capitol Hill', 'Ballard', 'Fremont', 'International District', 'Pike Place', 'Georgetown'],
    knownFor: 'Pike Place Market, wild salmon, coffee culture, International District, PNW cuisine',
    nearby: ['portland', 'san-francisco', 'boise']
  },
  'denver': {
    name: 'Denver', state: 'CO', population: '715K', restaurants: '3,500+',
    tagline: 'Mile-high dining, mountain-fresh flavors',
    foodScene: 'Denver\'s food has boomed with its population. RiNo is the epicenter with converted warehouses housing innovative restaurants. Green chile smothers everything. The craft beer scene rivals any city in America with 100+ breweries in metro.',
    topCuisines: [
      { emoji: '🌶️', name: 'Green Chile', note: 'Smothered on everything' },
      { emoji: '🍺', name: 'Craft Beer', note: '100+ breweries in metro area' },
      { emoji: '🥩', name: 'Colorado Beef', note: 'Ranch-raised steaks' },
      { emoji: '🌮', name: 'Mexican', note: 'Federal Blvd taco trail' },
      { emoji: '🍔', name: 'Craft Burgers', note: 'Green chile cheeseburgers' },
      { emoji: '🥗', name: 'Health-Focused', note: 'Active lifestyle meets food' }
    ],
    neighborhoods: ['RiNo', 'LoDo', 'Capitol Hill', 'Highlands', 'South Broadway', 'Tennyson'],
    knownFor: 'Green chile, craft beer, RiNo food scene, Colorado beef, Rocky Mountain oysters',
    nearby: ['salt-lake-city', 'albuquerque', 'kansas-city']
  },
  'boston': {
    name: 'Boston', state: 'MA', population: '675K', restaurants: '3,800+',
    tagline: 'Historic city, world-class seafood',
    foodScene: 'Boston\'s food identity is built on New England seafood — lobster rolls, clam chowder, and oyster bars. The Seaport is a dining destination, Cambridge brings creativity, and the North End is one of America\'s best Italian neighborhoods.',
    topCuisines: [
      { emoji: '🦞', name: 'Lobster Rolls', note: 'Hot butter or cold mayo' },
      { emoji: '🍲', name: 'Clam Chowder', note: 'New England-style only' },
      { emoji: '🍝', name: 'Italian', note: 'North End trattorias' },
      { emoji: '🦪', name: 'Oyster Bars', note: 'Island Creek & local catches' },
      { emoji: '🍀', name: 'Irish Pubs', note: 'Historic Southie & downtown' },
      { emoji: '🥡', name: 'Asian', note: 'Chinatown & Allston' }
    ],
    neighborhoods: ['North End', 'Seaport', 'Back Bay', 'South End', 'Cambridge', 'Allston'],
    knownFor: 'Lobster rolls, clam chowder, North End Italian, oyster bars, Faneuil Hall',
    nearby: ['new-york', 'philadelphia', 'portland']
  },
  'miami': {
    name: 'Miami', state: 'FL', population: '470K', restaurants: '4,200+',
    tagline: 'Latin flavor meets Art Deco glam',
    foodScene: 'Miami is where Latin America meets the Caribbean meets South Beach glamour. Cuban coffee and croquetas fuel the city, Little Havana is a living monument, and Wynwood is an outdoor gallery of art and food. Seafood is Gulf-fresh and the nightlife-dining crossover is unmatched.',
    topCuisines: [
      { emoji: '🇨🇺', name: 'Cuban', note: 'Ventanitas, croquetas, ropa vieja' },
      { emoji: '🐟', name: 'Seafood', note: 'Stone crab & Gulf-fresh catches' },
      { emoji: '🥘', name: 'Peruvian', note: 'Ceviche & lomo saltado' },
      { emoji: '🌴', name: 'Caribbean', note: 'Jamaican jerk, Haitian griot' },
      { emoji: '🥩', name: 'Argentine', note: 'Steakhouses & empanadas' },
      { emoji: '🍣', name: 'Japanese-Latin Fusion', note: 'Nikkei cuisine' }
    ],
    neighborhoods: ['Little Havana', 'Wynwood', 'Brickell', 'South Beach', 'Coral Gables', 'Design District'],
    knownFor: 'Cuban food, stone crab, Little Havana, South Beach dining, Latin fusion',
    nearby: ['orlando', 'tampa', 'jacksonville']
  },
  'atlanta': {
    name: 'Atlanta', state: 'GA', population: '500K', restaurants: '3,200+',
    tagline: 'Southern hospitality on every plate',
    foodScene: 'Atlanta is the capital of the modern South — traditional soul food meets innovative Southern cuisine. Buford Highway is a legendary international food strip. From Waffle House at 3am to a 10-course tasting in Buckhead, Atlanta covers every mood.',
    topCuisines: [
      { emoji: '🍗', name: 'Southern & Soul Food', note: 'Fried chicken, collards, mac & cheese' },
      { emoji: '🍑', name: 'Modern Southern', note: 'Chef-driven takes on classics' },
      { emoji: '🌮', name: 'Buford Hwy International', note: 'Vietnamese, Korean, Mexican' },
      { emoji: '🥘', name: 'Ethiopian', note: 'One of America\'s best scenes' },
      { emoji: '🍖', name: 'BBQ', note: 'Georgia-style smoked meats' },
      { emoji: '🧇', name: 'Brunch', note: 'Atlanta takes brunch seriously' }
    ],
    neighborhoods: ['Buford Highway', 'Westside', 'Buckhead', 'Midtown', 'Decatur', 'Ponce City'],
    knownFor: 'Buford Highway, Southern soul food, fried chicken, Ponce City Market, peach everything',
    nearby: ['nashville', 'charlotte', 'savannah']
  },
  'nashville': {
    name: 'Nashville', state: 'TN', population: '690K', restaurants: '2,800+',
    tagline: 'Hot chicken and honky-tonk dining',
    foodScene: 'Nashville\'s food revolves around hot chicken — the fiery, cayenne-crusted fried chicken invented here. Beyond the heat, The Gulch has chef-driven restaurants, meat-and-three diners serve unchanged recipes, and the biscuit culture takes breakfast to another level.',
    topCuisines: [
      { emoji: '🔥', name: 'Hot Chicken', note: 'Prince\'s, Hattie B\'s, Bolton\'s' },
      { emoji: '🍖', name: 'BBQ', note: 'Tennessee pork & dry rubs' },
      { emoji: '🧈', name: 'Biscuits', note: 'Nashville breakfast essential' },
      { emoji: '🍽️', name: 'Meat-and-Three', note: 'Pick a protein + 3 sides' },
      { emoji: '🍳', name: 'Brunch', note: 'Weekend lines are a badge' },
      { emoji: '🍗', name: 'Southern Comfort', note: 'Catfish, cornbread, sweet tea' }
    ],
    neighborhoods: ['East Nashville', 'The Gulch', '12South', 'Germantown', 'Midtown', 'Marathon Village'],
    knownFor: 'Nashville hot chicken, meat-and-three, biscuits, The Gulch, honky-tonk dining',
    nearby: ['memphis', 'atlanta', 'louisville']
  },
  'portland': {
    name: 'Portland', state: 'OR', population: '650K', restaurants: '3,000+',
    tagline: 'Food carts, craft everything, zero pretension',
    foodScene: 'Portland is the food cart capital of America — over 500 carts in pods. The ethos is hyper-local, seasonal, and unapologetically weird. Craft beer and coffee scenes are elite. Portlanders take food seriously but never make it stuffy.',
    topCuisines: [
      { emoji: '🚚', name: 'Food Carts', note: '500+ carts in pods citywide' },
      { emoji: '🍩', name: 'Doughnuts', note: 'Voodoo Doughnut & beyond' },
      { emoji: '🍺', name: 'Craft Beer', note: '70+ breweries in the city' },
      { emoji: '☕', name: 'Coffee', note: 'Third-wave roasters everywhere' },
      { emoji: '🥗', name: 'Farm-to-Table', note: 'Willamette Valley bounty' },
      { emoji: '🍜', name: 'Asian', note: 'Jade District & SE Portland' }
    ],
    neighborhoods: ['Hawthorne', 'Alberta Arts', 'Division', 'Pearl District', 'Mississippi', 'Sellwood'],
    knownFor: 'Food cart pods, Voodoo Doughnut, craft beer, farm-to-table, keep Portland weird',
    nearby: ['seattle', 'san-francisco', 'boise']
  },
  'las-vegas': {
    name: 'Las Vegas', state: 'NV', population: '650K', restaurants: '4,500+',
    tagline: 'Every celebrity chef has a restaurant here',
    foodScene: 'Las Vegas has more celebrity chef restaurants per square mile than anywhere on Earth. Off-Strip, Chinatown (Spring Mountain Road) is one of America\'s most underrated Asian food corridors. The buffet era is fading, replaced by world-class dining at every price point.',
    topCuisines: [
      { emoji: '🎰', name: 'Celebrity Chef', note: 'Ramsay, Andrés, Batali, Fieri' },
      { emoji: '🥡', name: 'Asian', note: 'Spring Mountain Rd Chinatown' },
      { emoji: '🍖', name: 'Steakhouses', note: 'High-roller chophouses' },
      { emoji: '🍣', name: 'Japanese', note: 'Omakase counters on & off Strip' },
      { emoji: '🌮', name: 'Mexican', note: 'East Las Vegas authenticity' },
      { emoji: '🍝', name: 'Italian', note: 'Strip dining to local spots' }
    ],
    neighborhoods: ['The Strip', 'Chinatown', 'Downtown/Fremont', 'Summerlin', 'Henderson', 'Arts District'],
    knownFor: 'Celebrity chef restaurants, Chinatown corridor, Strip dining, steakhouses, buffets',
    nearby: ['los-angeles', 'phoenix', 'san-diego']
  },
  'detroit': {
    name: 'Detroit', state: 'MI', population: '670K', restaurants: '2,500+',
    tagline: 'Grit, soul, and a food renaissance',
    foodScene: 'Detroit is in an incredible culinary comeback. Corktown has become a nationally recognized food district. Detroit-style pizza has gone viral. Middle Eastern food in Dearborn is the best in America. The Coney Island hot dog rivalry is a cultural institution.',
    topCuisines: [
      { emoji: '🍕', name: 'Detroit-Style Pizza', note: 'Thick, square, cheese-crusted edges' },
      { emoji: '🌭', name: 'Coney Dogs', note: 'American vs Lafayette' },
      { emoji: '🧆', name: 'Middle Eastern', note: 'Dearborn\'s legendary corridor' },
      { emoji: '🍖', name: 'BBQ & Soul Food', note: 'Slow-smoked ribs & greens' },
      { emoji: '🍔', name: 'Sliders', note: 'Invented here' },
      { emoji: '🍺', name: 'Craft Beer', note: 'Atwater, Batch, Brew Detroit' }
    ],
    neighborhoods: ['Corktown', 'Midtown', 'Dearborn', 'Eastern Market', 'Mexicantown', 'Hamtramck'],
    knownFor: 'Detroit-style pizza, Coney dogs, Dearborn Middle Eastern, Corktown renaissance',
    nearby: ['chicago', 'cleveland', 'columbus']
  }
};

export default CITIES;
